<template>
  <div class="insertion">
    <!-- <div class="chooseModel" v-if="hasModel">
      <div>选择模板</div>
      <select @change="changeSelect($event)" v-model="changeOption">
        <option value="0">不选择模板,新增</option>
        <option
          v-for="(item, index) in options"
          :key="index"
          :value="JSON.stringify(item)"
          >{{ item.ad_name }}</option
        >
      </select>
      <span @click="delModel(delid)">删除</span>
    </div> -->
    <div class="insertion_box">
      <!-- <van-field
        ref="textInsertion"
        v-model="insertion"
        size="large"
        rows="4"
        autosize
        type="textarea"
        value="insertion"
        placeholder="输入插入的文字..."
        show-word-limit
      /> -->
      <div style="height: .2rem;"></div>
      <textarea
        ref="textInsertion"
        placeholder="输入插入的文字..."
        v-model="insertion"
        maxlength="-1"
        @blur="onBlur"
      ></textarea>
      <!-- <div class="uploader" @click="uploder_show = true">
        <img
          class="icon"
          src="http://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/lc_add_img.png"
        />
        <van-icon class="icon" name="plus" size=".44rem" />
        <p ><span>添加图片</span></p>
      </div> -->
      <div class="uploader" v-if="imgs.length == 0">
        <input type="file" class="file" @change="upImg" ref="file" />
        <van-icon class="icon" name="plus" size=".44rem" />
        <!-- <img
          class="icon"
          src="http://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/lc_add_img.png"
        /> -->
        <p><span>添加图片</span></p>
      </div>
      <div class="img" v-for="(item, index) in imgs" :key="index">
        <img :src="item" />
        <div class="img_btn">
          <div class="item" @click="delimg(index)">
            <van-icon name="close" size=".32rem" color="#ffffff" />
            <span>删除图片</span>
          </div>
          <div class="item">
            <input
              type="file"
              class="file"
              @change="changeupImg($event, index)"
            />
            <van-icon name="replay" size=".32rem" color="#ffffff" />
            <span>替换图片</span>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="check" @click="checked = !checked">
      <van-checkbox v-model="checked" checked-color="#ee0a24"></van-checkbox>
      <span :style="checked ? 'color:#ee0a24' : ''">插入所有文章上方</span>
      <span>所有文章都自动插入该内容</span>
    </div> -->
    <div class="btn" @click="submit">确定插入</div>
    <!-- <p class="no_data">没有更多了</p> -->
    <div class="choosemodelNew" v-if="hasModel">
      <div class="choosemodelNewT">选中模板</div>
      <div
        class="choosemodelNewC"
        v-for="(item, index) in options"
        :key="index"
      >
        <div
          class="choosemodelNewC_t"
          @click="checkModel(JSON.stringify(item))"
        >
          <div class="titlename">{{ item.ad_name }}</div>
          <div class="imgall">
            <img :src="item.ad_image" style="width: 100%;" />
          </div>
        </div>
        <div class="choosemodelNew_b">
          <span @click="checkModel(JSON.stringify(item))">修改</span>
          <span @click="delModel(item.id)">删除</span>
          <div class="setmain">
            <img
              @click="setMianModel(item, index)"
              :src="
                item.is_default == 1
                  ? 'https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/yz_off2.png'
                  : 'https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/yz_off1.png'
              "
            /><label>{{ item.is_default == 1 ? "默认模板" : "非默认" }}</label>
          </div>
          <!-- <span @click="setMainModel(item.id)">默认</span> -->
        </div>
      </div>
    </div>
    <div style="height: 1rem;"></div>
    <div class="loadingBox" v-if="addLoading">
      <van-loading
        size="24px"
        vertical
        style="position: absolute;left: 50%;top: 50%;transform: translate(-50%,-50%);"
        >上传中...</van-loading
      >
    </div>
  </div>
</template>

<script>
import {
  Field,
  ActionSheet,
  Checkbox,
  Icon,
  Dialog,
  Toast,
  Loading
} from "vant";
import {
  getShare,
  getArticleAdNew,
  getUploadImageNew,
  getAdListNew,
  getDelAdNew,
  getAddAdDefault,
  getDelAdDefault
} from "@api/public";
import { cookie } from "@utils/store/cookie";
import { openShareAll, wxShowLocation } from "@libs/wechat";
import { isWeixin } from "@utils/index";
export default {
  name: "Insertion",
  components: {
    [Loading.name]: Loading,
    [ActionSheet.name]: ActionSheet,
    [Field.name]: Field,
    [Checkbox.name]: Checkbox,
    [Icon.name]: Icon,
    [Dialog.confirm.name]: Dialog.confirm
  },
  data() {
    return {
      addLoading: false,
      hasModel: false,
      urlAttr: "", //存储接收的广告位置：head,buttom
      urlSecret_key: "",
      urlAdid: "",
      urlGg: {
        ad_image: [],
        ad_name: "",
        ad_id: ""
      },
      imgs: [],
      insertion: "", // 插入的文章
      checked: true, // 是否插入所有文章上方
      options: [],
      ackOptions: "",
      delid: "", //删除选中的模本id
      uploder_show: false, // 添加图片弹窗
      uploder_actions: [
        {
          name: "拍照"
        },
        {
          name: "从手机相册选择"
        }
      ] // 修改头像弹窗选项
    };
  },
  mounted: function() {
    this.urlAttr = this.$route.query.attr;
    this.urlSecret_key = this.$route.query.secret_key;
    if (this.$route.query.gg.length > 5) {
      this.urlGg = JSON.parse(this.$route.query.gg);
      this.insertion = this.urlGg.ad_name;
      this.imgs = this.urlGg.ad_image;
      // this.urlAdid = this.urlGg.ad_id ? this.urlGg.ad_id : "";
      this.urlAdid = "";
      //修改
    } else {
      console.log("22");
      // 新建
    }
    this.getAdListNew();
    console.log(" this.urlAdid:", this.urlAdid);
    console.log("广告插入位置this.urlAttr :", this.urlAttr);
  },
  methods: {
    onBlur() {
      document.body.addEventListener("focusout", () => {
        setTimeout(() => {
          const scrollHeight =
            document.documentElement.scrollTop || document.body.scrollTop || 0;
          window.scrollTo(0, Math.max(scrollHeight - 1, 0));
        }, 100);
      });
    },
    /**
     * 确定插入
     */
    upImg(e) {
      let that = this;
      that.$refs.textInsertion.blur();
      that.addLoading = true;
      var files = e.target.files[0];
      var formD1 = new FormData();
      formD1.append("file", e.target.files[0]);
      getUploadImageNew(formD1)
        .then(res => {
          that.imgs.push(res.data.url);
          that.addLoading = false;
        })
        .catch(err => {
          Toast("上传失败！");
          that.addLoading = false;
        });
    },
    changeupImg(e, index) {
      let that = this;
      that.$refs.textInsertion.blur();
      that.addLoading = true;
      var files = e.target.files[0];
      var formD = new FormData();
      formD.append("file", e.target.files[0]);
      getUploadImageNew(formD)
        .then(res => {
          that.imgs.splice(index, 1, res.data.url);
          that.addLoading = false;
        })
        .catch(err => {
          Toast("上传失败！");
          that.addLoading = false;
        });
    },
    delimg(index) {
      this.imgs.splice(index, 1);
    },
    submit() {
      var that = this;
      that.$refs.textInsertion.blur();
      if (that.imgs.length == 0) {
        return Toast("请务必添加至少一张图片内容");
      }
      var data = {
        ad_name: that.insertion,
        ad_image: that.imgs.join(","),
        ad_id: that.urlAdid ? parseInt(that.urlAdid) : "",
        secret_key: that.urlSecret_key,
        type: that.urlAttr
      };
      getArticleAdNew(data).then(res => {
        Toast(res.msg);
        return that.$router.go(-1);
      });
    },
    getAdListNew() {
      getAdListNew()
        .then(res => {
          this.hasModel = true;
          this.options = res.data;
        })
        .catch(err => {
          this.hasModel = false;
        });
    },
    // 设置默认模板
    setMianModel(item, index) {
      let that = this;
      if (item.is_default == 1) {
        //表示此次为默认状态，需要取消默认；
        getDelAdDefault({ ad_id: item.id }).then(res => {
          // that.options[index].is_default=0;
          that.getAdListNew();
        });
      } else {
        //表示此时为非默认状态，需要设置其为默认，那就需要取消其他模板的默认
        let num = 0;
        if (that.options.length > 1) {
          for (var i = 0; i < that.options.length; i++) {
            num = i;
            if (that.options[i].is_default == 1) {
              getDelAdDefault({ ad_id: that.options[i].id }).then(res => {
                // that.options[i].is_default=0;
              });
            }
            if (num == that.options.length - 1) {
              setTimeout(function() {
                getAddAdDefault({ ad_id: item.id }).then(res => {
                  // that.options[index].is_default=1;
                  that.getAdListNew();
                });
              }, 300);
            }
          }
        } else {
          getAddAdDefault({ ad_id: item.id }).then(res => {
            // that.options[index].is_default=1;
            that.getAdListNew();
          });
        }
      }
    },
    checkModel(e) {
      this.ackOptions = JSON.parse(e);
      this.urlGg = this.ackOptions;
      this.insertion = this.ackOptions.ad_name;
      this.imgs = this.ackOptions.ad_image
        ? this.ackOptions.ad_image.split(",")
        : [];
      this.urlAdid = this.ackOptions.id ? this.ackOptions.id : "";
      this.delid = this.ackOptions.id;
      console.log("this.ackOptions.id:", this.ackOptions.id);
      console.log("this.urlAdid:", this.urlAdid);
      //页面选中后直接滚动到顶部
      window.scrollTo(0, 0);
    },
    changeSelect(e) {
      if (e == 0) {
        //新增
        this.urlAdid = "";
        (this.urlGg = {
          ad_image: [],
          ad_name: "",
          ad_id: ""
        }),
          (this.imgs = []);
        this.insertion = ""; // 插入的文章
        return;
      }
      this.ackOptions = JSON.parse(e.target.value);
      this.urlGg = this.ackOptions;
      this.insertion = this.ackOptions.ad_name;
      this.imgs = this.ackOptions.ad_image
        ? this.ackOptions.ad_image.split(",")
        : [];
      this.urlAdid = this.ackOptions.id ? this.ackOptions.id : "";
      this.delid = this.ackOptions.id;
      console.log("this.ackOptions.id:", this.ackOptions.id);
      console.log("this.urlAdid:", this.urlAdid);
    },
    delModel(id) {
      // if (this.delid == "") {
      //   return Toast("请务必选择模板");
      // }

      this.delid = id;
      console.log("this.delid:", this.delid);
      Dialog.confirm({
        title: "提示窗",
        message: "您确定要删除本条模板"
      })
        .then(() => {
          // on confirm
          getDelAdNew({ id: this.delid }).then(res => {
            this.getAdListNew();
            Toast(res.msg);
            if (this.urlAdid == this.delid) {
              //表示本条删除的模板是渲染的模板，删除后，导致渲染的数据为新增
              return (this.urlAdid = "");
            }
          });
        })
        .catch(() => {
          // on cancel
          Toast("取消删除");
        });
    },
    setOpenShare() {
      if (isWeixin()) {
        getShare().then(res => {
          var data = res.data.data;
          var configAppMessage = {
            desc: data.synopsis,
            title: data.title,
            link: "https://jdbeautycm.congwa.xyz",
            imgUrl: data.img
          };
          openShareAll(configAppMessage);
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.choosemodelNew {
  width: 100%;
  margin: 1rem auto;
  position: relative;
}
.choosemodelNewT {
  width: 95%;
  margin: 0 auto;
  font-size: 0.32rem;
  color: #000;
  line-height: 0.8rem;
}
.choosemodelNewC {
  background-color: #fff;
  margin-bottom: 0.25rem;
  position: relative;
}
.choosemodelNewC_t {
  border-bottom: 0.02rem solid #f0f0f0;
  padding: 0.2rem 0.3rem;
  position: relative;
  min-height: 1.5rem;
  display: flex;
  justify-content: space-between;
}
.choosemodelNewC_t .titlename {
  color: #999;
  width: 68%;
}
.choosemodelNew_b {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0.2rem;
}
.choosemodelNew_b span {
  border: 0.02rem solid #ff410a;
  padding: 0.08rem 0.21rem;
  margin: 0 0.4rem;
  border-radius: 0.08rem;
  font-size: 0.25rem;
  color: #ff410a;
}
.setmain {
  display: flex;
  align-items: center;
  position: absolute;
  right: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  img {
    display: block;
    width: 1rem;
  }
  label {
    margin-left: 0.2rem;
    color: #999;
    font-size: 0.25rem;
  }
}
.imgall {
  width: 24%;
  height: 1.5rem;
  overflow: hidden;
}
textarea {
  display: block;
  width: 90%;
  margin: 0 auto;
  height: 2rem;
  margin-bottom: 0.3rem;
}
.insertion {
  .insertion_box {
    background: #fff;
    padding-bottom: 0.2rem;

    .uploader {
      margin: 0 0.3rem;
      border: 1px dashed #999999;
      height: 1.6rem;
      text-align: center;
      font-size: 0;
      position: relative;

      .icon {
        width: 0.44rem;
        height: 0.44rem;
        margin-top: 0.3rem;
      }

      p {
        margin-top: 0.1rem;

        span {
          font-size: 0.2rem;
          color: #999999;
        }
      }
    }

    .img {
      margin: 0 0.3rem;
      position: relative;
      font-size: 0;
      max-height: 5rem;
      overflow: hidden;

      img {
        width: 100%;
      }

      .img_btn {
        position: absolute;
        height: 0.8rem;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        justify-content: space-between;
        background: rgb(0, 0, 0, 0.3);

        .item {
          display: flex;
          align-items: center;
          flex: 1;
          text-align: center;
          line-height: 0.8rem;
          justify-content: center;
          position: relative;

          &:first-child {
            &::after {
              position: absolute;
              right: 0;
              width: 0.015rem;
              height: 60%;
              content: "";
              background: #161010;
              border-radius: 0.1rem;
            }
          }

          img {
            width: 0.32rem;
            height: 0.32rem;
          }

          span {
            font-size: 0.24rem;
            color: #fff;
            margin-left: 0.1rem;
          }
        }
      }
    }
  }
  .file {
    opacity: 0;
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99;
  }
  .check {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0.3rem 0.3rem 0 0.3rem;

    span {
      &:last-child {
        font-size: 0.24rem;
        color: #999999;
      }
    }
  }

  .btn {
    background: #ff410a;
    line-height: 0.8rem;
    text-align: center;
    border-radius: 0.16rem;
    color: #ffffff;
    letter-spacing: 0.06rem;
    font-size: 0.3rem;
    width: calc(100% - 0.6rem);
    margin: 0.36rem auto 0;
  }

  .no_data {
    text-align: center;
    color: #999999;
    margin-top: 0.36rem;
  }
}
.loadingBox {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  z-index: 999;
}
.chooseModel {
  width: 95%;
  margin: 0.2rem auto;
  position: relative;
  font-size: 0.26rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
select {
  width: 55%;
  height: 0.8rem;
  border: 0.02rem solid #999;
  padding: 0 0.12rem;
  border-radius: 0.1rem;
  font-size: 0.22rem;
}
select option {
  font-size: 0.22rem !important;
}
.chooseModel span {
  display: block;
  width: 1.5rem;
  height: 0.6rem;
  text-align: center;
  line-height: 0.6rem;
  background: #999;
  color: #fff;
  font-size: 0.24rem;
  border-radius: 0.08rem;
}
</style>
